// External modules
import React from 'react';
import { isEmpty, cloneDeep } from 'lodash';
import moment from 'moment';
import universalCookie from 'universal-cookie';

import FavoriteRoundedIcon from '@material-ui/icons/FavoriteRounded';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';

// Internal modules
import ACDropDown from '../../atoms/ACDropDown';
import ACButton from '../../atoms/ACButton';
import {
    getStatuses,
    getDays,
    getDietaries,
    getConfirmationSentValues,
    getCodeSentValues,
    getRouteSetValues,
    getAuthStatusValues,
    getProductCategories,
    getProviderBookingStatuses,
    getProviderPaymentStatus,
    getSimpleFilters
} from '../../common/global';
import ACDateTimeRange from '../../atoms/ACDateTimeRange';
import { getOptionalFilterControls } from '../../common/global';

import styles from './ACFilter.module.scss';

const cookies = new universalCookie();
const userPreferencesCookieKey = 'ac-user-preferences';
const selectedStyle = {
    borderColor: 'red',
    borderWidth: '2px',
};

export default class ACFilter extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            countries: [],
            states: [],
            cities: [],
            // FIXME: Preferences to be loaded
            // a hack as a work around because the state was kept on being overriden
            loadPreferences: [],
            filters: {
                countries: [],
                states: [],
                cities: [],
                optionals: [], // The list of filters available for a page.
                optionalsFilters: {
                    bookingDate: {
                        from: moment(new Date()).format('YYYY-MM-DD'),
                        to: null,
                    },
                    bookingStatuses: [],
                    confirmationSentValues: [],
                    codeSentValues: [],
                    routeSetValues: [],
                    days: [], // Content of the optional filters you select.
                    dietaries: [],
                    hqId: '',
                    owners: [],
                    pageNumber: 0,
                    providerStatuses: [],
                    productName: '',
                    bookingRouteStopItemActivityStatuses: [],
                    productCategories: [],
                    providerBookingStatus: [],
                    providerPaymentStatus: [],
                    subscriptionStatus: [],
                    authStatusValues: [],
                    isPersonalisationCompleted: [],
                    surveyCompleted:[],
                },
                optionalFilterControls: [], // The UI options of what the user can select.
            },
            resetFilters: false,
        };
    }

    //FIXME: Deprecated
    componentWillReceiveProps(props) {
        // TODO: Ask Umar, not usre what this one is for
        if (props.resetFilters) {
            if (props.resetFilters === true) this.resetAllFilters();
        }

        if (props.countries) {
            this.setState({
                countries: props.countries,
            });
        }

        if (props.states) {
            this.setState({
                states: props.states,
            });
        }

        if (props.cities) {
            this.setState({
                cities: props.cities,
            });
        }
    }

    componentDidMount() {
        // FIXME: Preferences to be loaded
        // a hack as a work around because the state was kept on being overriden
        let userPreferences;
        const encodedUserPreferences = cookies.get(userPreferencesCookieKey) || null;
        try {
            userPreferences = JSON.parse(encodedUserPreferences);
        } catch (error) {
            userPreferences = encodedUserPreferences;
        }
        if (userPreferences) {
            userPreferences.optionalsFilters.bookingDate = {
                from: moment(new Date()).format('YYYY-MM-DD'),
                to: null,
            };
            let loadPreferences = [];
            if (!isEmpty(userPreferences.countries)) {
                loadPreferences.push({
                    key: 'countries',
                    value: userPreferences.countries,
                });
            }
            if (!isEmpty(userPreferences.states)) {
                loadPreferences.push({
                    key: 'states',
                    value: userPreferences.states,
                });
            }
            if (!isEmpty(userPreferences.cities)) {
                loadPreferences.push({
                    key: 'cities',
                    value: userPreferences.cities,
                });
            }

            // console.log('Loading userPreferences', loadPreferences);
            this.setState({
                filters: userPreferences,
                loadPreferences,
            });
        }
    }

    resetAllFilters() {
        const filters = this.state.filters;
        filters.countries = [];
        filters.states = [];
        filters.cities = [];
        filters.optionals = [];

        const optionalsFilters = filters.optionalsFilters;

        optionalsFilters.owners = [];
        optionalsFilters.days = [];
        optionalsFilters.dietaries = [];
        optionalsFilters.bookingStatuses = [];
        optionalsFilters.providerStatuses = [];
        optionalsFilters.hqId = '';
        optionalsFilters.productName = '';
        optionalsFilters.bookingDate = {
            from: moment(new Date()).format('YYYY-MM-DD'),
            to: '',
        };
        optionalsFilters.confirmationSentValues = [];
        optionalsFilters.codeSentValues = [];
        optionalsFilters.authStatusValues = [];
        optionalsFilters.productCategories = [];
        optionalsFilters.subscriptionStatus = [];
        optionalsFilters.providerBookingStatus = [];
        optionalsFilters.providerPaymentStatus = [];

        filters.optionalsFilters = optionalsFilters;

        filters.optionalFilterControls = [];
        this.setState({
            filters: filters,
        });
        this.passToProps('reset', null);
    }

    onClickClear() {
        this.resetAllFilters();
    }

    onChangeSelection(key, type, event) {
        if (type === 'Default') {
            this.onChangeSelectionFilters(key, event);
        } else if (type === 'Optional Filters Content') {
            this.onChangeSelectionOptionalFiltersContent(key, event);
        }
    }

    onChangeTextOptionalFiltersContent(key, event) {
        if (!key || !event) return;

        const {
            target: { value },
        } = event;

        const { filters } = this.state;
        const optionalsFilters = filters.optionalsFilters;

        optionalsFilters[key] = value;
        filters.optionalsFilters = optionalsFilters;

        this.setState({ filters });
    }

    /**
     * onKeyPress handler for the text field. Previously, we send calls to the back-end on EVERY key stroke.
     * This handler will allow us to send the request to backend only when the end user hit the "Enter" key on his/her keyboard
     * @param {*} key The text field key
     * @param {*} event onKeyPress event
     * @since 2020-01-16
     */
    onTextFieldKeyPress(key, event) {
        if (event.key === 'Enter') {
            const {
                filters: { optionalsFilters },
            } = this.state;
            const value = optionalsFilters[key];
            this.passToProps(key, value);
        }
    }

    onChangeDate = (fromOrTo, value) => {
        let filters = cloneDeep(this.state.filters);
        let bookingDate = filters.optionalsFilters.bookingDate;

        bookingDate[fromOrTo] = value;
        filters.optionalsFilters.bookingDate = bookingDate;

        this.setState({
            filters,
        });

        this.passToProps(fromOrTo, value);
    };

    onChangeSelectionFilters(key, event) {
        if (!key || !event) return;

        let values = event.target.value;
        let filters = cloneDeep(this.state.filters);
        let index = -1;

        index = values.indexOf(key);

        if (key === 'countries') {
            this.props.onChangeCountryFunc(values);
        }
        if (key === 'states') {
            this.props.onChangeStateFunc(values);
        }

        if (index >= 0) {
            values.splice(index, 1);
        }

        filters[key] = values;
        this.setState({
            filters,
        });

        // internal function to keep it readable and clean
        this.passToProps(key, values);
    }

    onChangeSelectionOptionalFiltersContent(key, event) {
        if (!key || !event) return;

        let values = event.target.value;

        let filters = cloneDeep(this.state.filters);
        let optionalsFilters = filters.optionalsFilters;

        optionalsFilters[key] = values;
        filters.optionalsFilters = optionalsFilters;

        this.setState({
            filters,
        });

        // internal function to keep it readable and clean
        this.passToProps(key, values);
    }

    // TODO: At this stage, We rely on cookie to store user preferences.
    // we might want to find a better approach in the future
    onClickFavourite = () => {
        const filters = cloneDeep(this.state.filters);
        filters.optionalsFilters.bookingDate = null;
        cookies.set(userPreferencesCookieKey, JSON.stringify(filters), {
            path: '/',
        });
        alert('Preferences Saved!');
    };

    passToProps(key, data) {
        switch (key) {
            case 'countries':
                this.props.onFilterCountriesFunc(data);
                break;
            case 'states':
                this.props.onFilterStatesFunc(data);
                break;
            case 'cities':
                this.props.onFilterCitiesFunc(data);
                break;
            case 'hqId':
                this.props.onFilterBookingsFunc(data);
                break;
            case 'owners':
                this.props.onFilterOwnersFunc(data);
                break;
            case 'days':
                this.props.onFilterDaysFunc(data);
                break;
            case 'dietaries':
                this.props.onFilterDietariesFunc(data);
                break;
            case 'bookingStatuses':
                this.props.onFilterBookingStatusesFunc(data);
                break;
            case 'confirmationSentValues':
                this.props.onFilterConfirmationSentFunc(data);
                break;
            case 'codeSentValues':
                this.props.onFilterCodeSentFunc(data);
                break;
            case 'routeSetValues':
                this.props.onFilterRouteSetFunc(data);
                break;
            case 'authStatusValues':
                this.props.onFilterAuthStatusFunc(data);
                break;
            case 'from':
            case 'to':
                this.props.onFilterDateFunc(key, data);
                break;
            case 'productName':
                this.props.onFilterByProductNameFunc(data);
                break;
            case 'pageNumber':
                this.props.onFilterByPageNumberFunc(data);
                break;
            case 'bookingRouteStopItemActivityStatuses':
                this.props.onFilterByBookingRouteStopItemActivityStatusFunc(data);
                break;
            case 'productCategories':
                this.props.onFilterProductCategoriesFunc(data);
                break;
            case 'subscriptionStatus':
                this.props.onFilterSubscriptionStatusFunc(data);
                break;
            case 'providerBookingStatus':
                this.props.onFilterByProviderBookingStatusFunc(data);
                break;
            case 'providerPaymentStatus':
                this.props.onFilterByProviderPaymentStatusFunc(data);
                break;
            case 'isPersonalisationCompleted':
                this.props.onFilterIsPersonalisationCompletedFunc(data);
                break;
            case 'surveyCompleted':
                this.props.onFilterIsSurveryCompletedFunc(data);
                break;
            case 'reset':
                this.props.onClearFilterFunc();
                break;                 
            default:
                break;
        }
    }

    getMultipleSelectDropDown(options, selected, type, key, text) {
        return (
            <div className={styles.filterSelect} style={!isEmpty(selected) ? selectedStyle : {}} key={key}>
                <ACDropDown
                    text={text}
                    isEditable={true}
                    options={options}
                    selected={selected}
                    onChangeFunc={(e) => this.onChangeSelection(key, type, e)}
                    backgroundColor="#52A8EF"
                    color="white"
                    isMultiple={true}
                />
            </div>
        );
    }

    renderTextBox(key, value, placeHolder) {
        return (
            <div className={styles.filterText} style={!isEmpty(value) ? selectedStyle : {}} key={'filter' + key}>
                <TextField
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                    placeholder={placeHolder}
                    className={styles.search}
                    value={value}
                    onKeyPress={(e) => this.onTextFieldKeyPress(key, e)}
                    onChange={(e) => this.onChangeTextOptionalFiltersContent(key, e)}
                />
            </div>
        );
    }

    getDateRangeControl(from, to) {
        return (
            <div className={styles.filterDateTime} key={`${from}${to}`}>
                <ACDateTimeRange
                    from={from || null}
                    to={to || null}
                    onChangeDateFunc={this.onChangeDate}
                    type="KeyboardDatePicker"
                    format="DD/MM/YYYY"
                    classNameFromIcon={styles.dateRangeIcon}
                    classNameToIcon={styles.dateRangeIcon}
                />
            </div>
        );
    }

    renderBookingFilter() {
        const filterBooking = this.state.filters.optionalsFilters.hqId;
        return this.renderTextBox('hqId', filterBooking, 'Filter by HQ Id');
    }

    /**
     * Render the Filter by product name text field
     */
    renderProductNameFilter() {
        const {
            filters: {
                optionalsFilters: { productName },
            },
        } = this.state;

        return this.renderTextBox('productName', productName, 'Filter By Product Name');
    }

    renderBookingDateRangeFilter() {
        const bookingDate = this.state.filters.optionalsFilters.bookingDate;

        return this.getDateRangeControl(moment(bookingDate.from), bookingDate.to);
    }

    renderBookingRouteStopItemActivityStatusFilter() {
        const bookingRouteStopItemActivityStatuses =
            this.state.filters.optionalsFilters.bookingRouteStopItemActivityStatuses;

        return this.getMultipleSelectDropDown(
            ['Not Complete', 'Completed', 'Not Requested','Requested/Complete'],
            bookingRouteStopItemActivityStatuses,
            'Optional Filters Content',
            'bookingRouteStopItemActivityStatuses',
            'Provider Item Status'
        );
    }

    renderProviderStatusesFilter() {
        const filterProviderStatuses = this.state.filters.optionalsFilters.providerStatuses;

        const statuses = getStatuses('providerBooking');
        const providerStatuses = statuses.map((status) => {
            return status;
        });
        return this.getMultipleSelectDropDown(
            providerStatuses,
            filterProviderStatuses,
            'Optional Filters Content',
            'providerStatuses',
            'Provider Statuses'
        );
    }

    renderBookingStatusesFilter() {
        const filterBookingStatuses = this.state.filters.optionalsFilters.bookingStatuses;

        const statuses = getStatuses('booking');
        const bookingStatuses = statuses.map((status) => {
            return status;
        });

        return this.getMultipleSelectDropDown(
            bookingStatuses,
            filterBookingStatuses,
            'Optional Filters Content',
            'bookingStatuses',
            'Booking Statuses'
        );
    }

    renderConfirmationSentFilter() {
        const filterConfirmationSentValues = this.state.filters.optionalsFilters.confirmationSentValues;

        const values = getConfirmationSentValues();
        const confirmationSentValues = values.map((val) => {
            return val;
        });
        return this.getMultipleSelectDropDown(
            confirmationSentValues,
            filterConfirmationSentValues,
            'Optional Filters Content',
            'confirmationSentValues',
            'Confirmation Sent'
        );
    }

    renderCodeSentFilter() {
        const filterCodeSentValues = this.state.filters.optionalsFilters.codeSentValues;

        const values = getCodeSentValues();
        const codeSentValues = values.map((val) => {
            return val;
        });
        return this.getMultipleSelectDropDown(
            codeSentValues,
            filterCodeSentValues,
            'Optional Filters Content',
            'codeSentValues',
            'Code Sent'
        );
    }

    renderRouteSetFilter() {
        const filterRouteSetValues = this.state.filters.optionalsFilters.routeSetValues;

        const values = getRouteSetValues();
        const routeSetValues = values.map((val) => {
            return val;
        });
        return this.getMultipleSelectDropDown(
            routeSetValues,
            filterRouteSetValues,
            'Optional Filters Content',
            'routeSetValues',
            'Route Set'
        );
    }

    renderAuthStatusFilter() {
        const filterAuthStatusValues = this.state.filters.optionalsFilters.authStatusValues;

        const values = getAuthStatusValues();
        const authStatusValues = values.map((val) => {
            return val;
        });
        return this.getMultipleSelectDropDown(
            authStatusValues,
            filterAuthStatusValues,
            'Optional Filters Content',
            'authStatusValues',
            'Auth Status'
        );
    }

    renderDaysFilter() {
        const days = this.state.filters.optionalsFilters.days;

        const suitableDays = getDays();

        return this.getMultipleSelectDropDown(suitableDays, days, 'Optional Filters Content', 'days', 'Days');
    }

    renderDietariesFilter() {
        const dietaries = this.state.filters.optionalsFilters.dietaries;

        const dietariesOptions = getDietaries();

        return this.getMultipleSelectDropDown(
            dietariesOptions,
            dietaries,
            'Optional Filters Content',
            'dietaries',
            'Dietaries'
        );
    }

    renderOwnersFilter(owners) {
        const ownersFilter = this.state.filters.optionalsFilters.owners;
        if (!owners) return;
        let ownersObj = [];
        ownersObj.push('Unassigned'); //added Unassinged filter option on top
        owners.forEach((o) => {
            ownersObj.push(o.name);
        });

        return this.getMultipleSelectDropDown(ownersObj, ownersFilter, 'Optional Filters Content', 'owners', 'Owners');
    }

    renderProductCategoriesFilter() {
        const filterProductCategories = this.state.filters.optionalsFilters.productCategories;
        let productCategories = getProductCategories();

        return this.getMultipleSelectDropDown(
            productCategories,
            filterProductCategories,
            'Optional Filters Content',
            'productCategories',
            'Product Categories'
        );
    }

    renderSubscriptionStatusFilter() {
        const subscriptionFilter = this.state.filters.optionalsFilters.subscriptionStatus;
        let subscriptionStatus = ['Standard', 'Premium', 'Free Forever', 'Cancelled'];

        return this.getMultipleSelectDropDown(
            subscriptionStatus,
            subscriptionFilter,
            'Optional Filters Content',
            'subscriptionStatus',
            'Subscription Status'
        );
    }

    renderCountriesFilter() {
        const filterCountries = this.state.filters.countries;

        let countries = [];
        if (this.state.countries) countries = this.state.countries;

        return this.getMultipleSelectDropDown(countries, filterCountries, 'Default', 'countries', 'Countries');
    }

    renderStatesFilter() {
        const filterStates = this.state.filters.states;

        let states = [];
        if (this.state.states) states = this.state.states;

        return this.getMultipleSelectDropDown(states, filterStates, 'Default', 'states', 'States');
    }

    renderCitiesFilter() {
        const filterCities = this.state.filters.cities;

        let cities = [];
        if (this.state.cities) cities = this.state.cities;

        return this.getMultipleSelectDropDown(cities, filterCities, 'Default', 'cities', 'Cities');
    }

    renderProviderBookingStatusFilter() {
        const providerBookingStatus = this.state.filters.optionalsFilters.providerBookingStatus;

        const providerBookiingStatusOptions = getProviderBookingStatuses();

        return this.getMultipleSelectDropDown(
            providerBookiingStatusOptions,
            providerBookingStatus,
            'Optional Filters Content',
            'providerBookingStatus',
            'Provider Booking Status'
        );
    }

    renderProviderPaymentStatusFilter() {
        const providerPaymentStatus = this.state.filters.optionalsFilters.providerPaymentStatus;

        const providerPaymentStatusOptions = getProviderPaymentStatus();

        return this.getMultipleSelectDropDown(
            providerPaymentStatusOptions,
            providerPaymentStatus,
            'Optional Filters Content',
            'providerPaymentStatus',
            'Provider Payment Status'
        );
    }
    renderIsPersonalisationCompletedFilter() {
        const personalisationStatus = this.state.filters.optionalsFilters.isPersonalisationCompleted;

        const personalisationOptions = getSimpleFilters();

        return this.getMultipleSelectDropDown(
            personalisationOptions,
            personalisationStatus,
            'Optional Filters Content',
            'isPersonalisationCompleted',
            'Personalisation Completed'
        );
    }

    renderIsSurveyCompletedFilter() {
        const personalisationStatus = this.state.filters.optionalsFilters.surveyCompleted;

        const personalisationOptions = getSimpleFilters();

        return this.getMultipleSelectDropDown(
            personalisationOptions,
            personalisationStatus,
            'Optional Filters Content',
            'surveyCompleted',
            'Survey Completed'
        );
    }
    

    renderMandatoryFilters(pageName) {
        // const bookingDate = this.state.filters.optionalsFilters.bookingDate;
        if (isEmpty(this.state.filters)) return <div />;
        const mandatoryFilter = [];

        if (pageName === 'planner') {
            mandatoryFilter.push(this.renderBookingFilter());
            mandatoryFilter.push(this.renderProductNameFilter());
            // console.log("bookingDate.from", bookingDate.from);
            mandatoryFilter.push(this.renderBookingDateRangeFilter());
            mandatoryFilter.push(this.renderBookingRouteStopItemActivityStatusFilter());
            mandatoryFilter.push(this.renderProviderBookingStatusFilter());
            mandatoryFilter.push(this.renderProviderPaymentStatusFilter());
        }
        mandatoryFilter.push(this.renderCountriesFilter());
        mandatoryFilter.push(this.renderStatesFilter());
        mandatoryFilter.push(this.renderCitiesFilter());

        return (
            <React.Fragment>
                {mandatoryFilter.map((mFilter) => {
                    return mFilter;
                })}
            </React.Fragment>
        );
    }

    renderOptionalFilterContent(pageName) {
        const allOptionalFilterControls = getOptionalFilterControls();

        let optionalFilterControls = allOptionalFilterControls[pageName]
            ? allOptionalFilterControls[pageName].optionalFilterControls
            : [];

        if (optionalFilterControls && optionalFilterControls.length > 0) {
            return optionalFilterControls.map((opF) => {
                let control = undefined;

                // Optional filters
                if (opF === 'days') control = this.renderDaysFilter();
                if (opF === 'dietaries') control = this.renderDietariesFilter();
                if (opF === 'owners') control = this.renderOwnersFilter(this.props.users);
                if (opF === 'providerStatuses') control = this.renderProviderStatusesFilter();
                if (opF === 'bookingStatuses') control = this.renderBookingStatusesFilter();
                if (opF === 'routeSet') control = this.renderRouteSetFilter();
                if (opF === 'confirmationSent') control = this.renderConfirmationSentFilter();
                if (opF === 'codeSent') control = this.renderCodeSentFilter();
                if (opF === 'authStatus') control = this.renderAuthStatusFilter();
                if (opF === 'bookingRouteStopItemActivityStatuses')
                    control = this.renderBookingRouteStopItemActivityStatusFilter();
                if (opF === 'productCategories') control = this.renderProductCategoriesFilter();
                if (opF === 'subscriptionStatus') control = this.renderSubscriptionStatusFilter();
                if (opF === 'isPersonalisationCompleted') control = this.renderIsPersonalisationCompletedFilter();
                if (opF === 'surveyCompleted') control = this.renderIsSurveyCompletedFilter();

                return control;
            });
        }
    }

    renderFavourite() {
        return (
            <div className={styles.filterFavourite}>
                <ACButton
                    icon={<FavoriteRoundedIcon key="favorite-icon" />}
                    iconLast={true}
                    padding="5px 0 0 0"
                    backgroundColor="#52A8EF"
                    color="white"
                    spanMargin="0 0"
                    key="btnFavourite"
                    onClickFunc={() => this.onClickFavourite()}
                />
            </div>
        );
    }

    renderClear() {
        return (
            <div className={styles.filterClear}>
                <ACButton
                    icon={<CloseOutlinedIcon key="close-icon" />}
                    iconLast={true}
                    padding="0px 0px"
                    backgroundColor="#52A8EF"
                    color="white"
                    spanMargin="0 0"
                    onClickFunc={() => this.onClickClear()}
                    margin="4px"
                />
            </div>
        );
    }

    render() {
        const { loadPreferences, filters } = this.state;
        const pageName = this.props.pageName;
        if (!this.state.filters) return <div />;

        // FIXME: Preferences to be loaded
        // a hack as a work around because the state was kept on being overriden
        if (!isEmpty(loadPreferences)) {
            const pref = loadPreferences.pop();
            filters[pref.key] = pref.value;

            this.setState({ loadPreferences, filters });
            this.passToProps(pref.key, pref.value);
        }

        return (
            <div className={styles.filterRoot}>
                {this.renderMandatoryFilters(pageName)}
                {this.renderOptionalFilterContent(pageName)}
                {this.renderClear()}
                {this.renderFavourite()}
            </div>
        );
    }
}
